// Dummy data for UVANDUS delivery portal

export const categories = [
 
];

export const products = [
 
];

export const userProfile = {
  id: 1,
  name: "John Doe",
  email: "john.doe@example.com",
  phone: "+1-555-0123",
  address: "123 Main Street, City, State 12345",
  avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
};

export const bookings = [
  {
    id: 1,
    orderNumber: "UV-2024-001",
    date: "2024-08-05",
    status: "Delivered",
    total: 45.67,
    items: [
      { productId: 1, name: "Fresh Whole Milk", quantity: 2, price: 2.99 },
      { productId: 3, name: "Fresh Tomatoes", quantity: 1, price: 1.99 },
      { productId: 5, name: "Chicken Breast", quantity: 2, price: 8.99 }
    ]
  },
  {
    id: 2,
    orderNumber: "UV-2024-002",
    date: "2024-08-03",
    status: "In Transit",
    total: 32.45,
    items: [
      { productId: 2, name: "Organic Cheddar Cheese", quantity: 1, price: 4.99 },
      { productId: 7, name: "Fresh Apples", quantity: 2, price: 3.99 },
      { productId: 9, name: "Fresh Bread", quantity: 1, price: 3.49 }
    ]
  }
];

export const bannerData = {
  title: "Fresh Delivery to Your Doorstep",
  subtitle: "Get fresh dairy, vegetables, and meat delivered within 2 hours",
  image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200&h=400&fit=crop",
  ctaText: "Shop Now"
}; 